import { __exports as defaults } from "./index156.js";
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults) return defaults;
  hasRequiredDefaults = 1;
  Object.defineProperty(defaults, "__esModule", {
    value: true
  });
  var defaults$1 = {
    width: 2,
    height: 100,
    format: "auto",
    displayValue: true,
    fontOptions: "",
    font: "monospace",
    text: void 0,
    textAlign: "center",
    textPosition: "bottom",
    textMargin: 2,
    fontSize: 20,
    background: "#ffffff",
    lineColor: "#000000",
    margin: 10,
    marginTop: void 0,
    marginBottom: void 0,
    marginLeft: void 0,
    marginRight: void 0,
    valid: function valid() {
    }
  };
  defaults.default = defaults$1;
  return defaults;
}
export {
  requireDefaults as __require
};
//# sourceMappingURL=index134.js.map
